function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H30V30H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#808285",
  d: "M23333.926 17787.066a9.987 9.987 0 1 1 7.074 2.934 9.658 9.658 0 0 1-7.074-2.934zm10.658-2.043l1.406-1.41-3.611-3.615 3.611-3.613-1.406-1.408-3.605 3.615-3.561-3.615-1.406 1.408 3.561 3.613-3.561 3.615 1.406 1.41 3.561-3.617z",
  transform: "translate(-23326 -17765)"
});

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    className: "bg-close",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.c18842d1.svg";
export { ForwardRef as ReactComponent };